/* Actions */
export const GET_REQUEST = "GET_REQUEST";
export const POST_REQUEST = "POST_REQUEST";
export const POPULATE_RECORD = "POPULATE_RECORD";

/* Mutations */
export const POPULATE_RECORD_SUCCESS = "POPULATE_RECORD_SUCCESS";
export const POPULATE_RECORD_ERROR = "POPULATE_RECORD_ERROR";
